<template>
<el-dialog :visible.sync="centerDialogVisible" class="lookimage" width="800px">
  <div style="position: relative;">
    <img-view style="width:800px;height:500px;position:absolute;" :imgUrl="image" background="#000"></img-view>
    <el-button style="position: absolute; top:0px;right:0px;background-color:transparent;border:none;color:#fff" @click="centerDialogVisible=false" icon="el-icon-close" circle></el-button>
  </div>
</el-dialog>
</template>

<script>
export default {
  data() {
    return {
      image: '',

      centerDialogVisible: false

    };
  },
  mounted() {

  },
  methods: {
    isOpen(images) {
      this.image = images
      this.centerDialogVisible = true
    },
    onsubmit() {
      this.centerDialogVisible = false;

    },

  },
}
</script>

<style lang="scss" scoped>
.lookimage {
  ::v-deep .el-dialog__header {
    display: none !important;
  }

  ::v-deep .el-dialog__body {
    padding: 0px;
  }
}

.text {

  font-size: 14px;
  margin-top: 17px;
  font-weight: 400;
  color: #1F233E;
  line-height: 24px;
}

.btn-check {
  width: 100px;
  height: 30px;
  background: #4C70E8;
  font-size: 14px;
  color: #ffffff;
  font-weight: bold;
  border-radius: 5px;
  padding: 0px;
}

.btn-off {
  width: 100px;
  height: 30px;
  background: #7B84A1;
  opacity: 0.5;
  border-radius: 5px;
  font-size: 14px;
  color: #ffffff;
  font-weight: bold;
  padding: 0px;
}

.bottom {

  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

}

::v-deep .el-textarea__inner {
  padding: 5px 10px;
  resize: none;
  height: 30px !important;
  border-radius: 0px;
  font-size: 12px;
  background-color: #F9F9FC;
  border: 1px solid #DEE0E7 !important;
}

::v-deep .el-dialog__body {
  padding: 0px 10px 20px 10px;

}

::v-deep .el-dialog__header {
  padding: 15px 20px;
}

::v-deep .el-dialog__title {
  height: 20px;
  font-size: 20px;

  font-weight: bold;
  color: #4C70E8;

}

::v-deep .el-divider--horizontal {

  margin: 20px 0;
}
</style>
